module.exports = __webpack_public_path__ + "static/media/cohorts-reader-2A.37a26f92.png";